import { FormHelperText } from "@material-ui/core";

interface HelperTextProps {
  className?: string;
  activo: boolean;
  texto: string;
  tipo: "error" | "info";
}

const HelperText: React.FC<HelperTextProps> = (props: HelperTextProps) => {
  const className = props.className ? props.className : "";
  const activo = props.activo && props.texto ? "" : "hidden";
  const error = props.tipo === "error" ? true : false;

  return (
    <FormHelperText
      className={`${className} ${activo} animated-transition`}
      error={error}
    >
      {props.texto}
    </FormHelperText>
  );
};

export default HelperText;
